<!-- GPR Spinner -->
<ng-container *ngIf="spinnerVisibility; then spinner"></ng-container>
<ng-template #spinner>
  <div class="spinner-overlay">
    <img class="m-auto" src="assets/img/gpr-spinner-blocks.svg">
  </div>
</ng-template>

<router-outlet></router-outlet>
